import * as firebase from 'firebase';

import Util from '../utils.js';

const database = firebase.firestore();

    async function GetColoresDefinidos() {

        const dataParam = {};
        //esta key debe ser dinaminca
        // iZTLJAcQU547ZhEUtp2f //documento de prueba
        const queryRes = await database.collection("bots").doc("fc6GTcE6zeTHgy3nEQNz").get();
        console.log('queryRes :>> ', queryRes);
        for (const key in queryRes) {
            const data = queryRes.data();
            dataParam.data = data;
        }
            
        return dataParam;
    }

    function PostColoresDefinidos(tipoColor, color) {
        // iZTLJAcQU547ZhEUtp2f //documento de prueba
        const updateDoc = database.collection("bots").doc("fc6GTcE6zeTHgy3nEQNz");

        switch (tipoColor) {
            case 'colorChatbot':
                return updateDoc.update({
                    color_bot: color,
                });

            case 'colorCliente':
                return updateDoc.update({
                    color_cliente: color,
                });

            case 'colorFondo':
                return updateDoc.update({
                    color_fondo: color,
                });

            case 'colorBarra':
                return updateDoc.update({
                    color_desplazamiento: color,
                });

            case 'colorTextoBot':
                return updateDoc.update({
                    color_texto_bot: color,
                });

            case 'colorTextoCli':
                return updateDoc.update({
                    color_texto_cliente: color,
                });

            default:
                return 'No se actualizo el color';
                
        }
    }


export default {
    GetColoresDefinidos,
    PostColoresDefinidos
}